<template>
  <report-section title="睡眠分期统计" style="position: relative">
    <template v-slot:content>
      <div class="sleep-period">
        <sleep-period-pie class="sleep-period-right" :dataArray="model.pieArray"></sleep-period-pie>
        <div class="sleep-period-left">
          <el-table :data="tableData" border stripe size="small" style="width: 100%">
            <el-table-column prop="title" label="睡眠阶段" width="100" align="center"></el-table-column>
            <el-table-column prop="time" label="持续时间(分钟)" width="120" align="center">
              <template slot-scope="scope">
                {{ scope.row.time }} 
              </template>
            </el-table-column>
            <el-table-column prop="ratio" label="总占比(%)" align="center">
              <template slot-scope="scope">
                {{ scope.row.ratio }}
              </template>
            </el-table-column>
          </el-table>
        </div>
       
      </div>
    </template>

  </report-section>
</template>


<script>
import SleepPeriodPie from "./sleep-period-pie.vue";
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
export default {
  components: {
    SleepPeriodPie,
    ReportSection,
  },
  props: {
    model: Object,
  },
  computed: {
    tableData() {
      
      return [
        {
          title: "WK",
          time: this.model.awakeTime,
          ratio: this.model.awakeRatio
        },
        {
          title: "REM",
          time: this.model.remTime,
          ratio: this.model.remRatio
        },
        {
          title: "N1",
          time: this.model.n1Time,
          ratio: this.model.n1Rate
        },
        {
          title: "N2",
          time: this.model.n2Time,
          ratio: this.model.n2Rate
        },
        // {
        //   title: "浅睡期",
        //   time: this.model.lightSleepTime,
        //   ratio: this.model.lightSleepRatio
        // },
        {
          title: "N3",
          time: this.model.deepSleepTime,
          ratio: this.model.deepSleepRatio
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.sleep-period {
  width: 100%;
  box-sizing: border-box;
  padding: rem(10) rem(20);
  display: flex;
  justify-content: space-between;

  &-left {
    width: 40%;
  }

  &-right {
    width: 50%;
  }
}

/* 自定义表格样式 */
:deep(.el-table) {
  font-size: rem(14);
  
  .el-table__header-wrapper th {
    background-color: #f5f7fa;
    color: #333;
    font-weight: bold;
  }
  
  .el-table__body-wrapper td {
    color: #333;
  }
}
</style>